<template>
  <layout>
    <page-header :header="$t('companies.create_company')" />
    <div class="content">
      <resource-form
        v-if="currentDivision"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'companies'

export default {
  name: 'CompanyCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
